// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "wrapper-3moVs";
var _4 = "wrapper_departure-2oaBb";
var _5 = "airport-3whe4";
var _6 = "airport_departure-1ICEi";
var _7 = "airport_terminal-1cHx-";
var _8 = "time-1idjk";
var _9 = "wrapper_mobile-3nkQ1";
var _a = "plane-2L0AW";
export { _1 as "__esModule", _2 as "tablet", _3 as "wrapper", _4 as "wrapper_departure", _5 as "airport", _6 as "airport_departure", _7 as "airport_terminal", _8 as "time", _9 as "wrapper_mobile", _a as "plane" }
export default { "__esModule": _1, "tablet": _2, "wrapper": _3, "wrapper_departure": _4, "airport": _5, "airport_departure": _6, "airport_terminal": _7, "time": _8, "wrapper_mobile": _9, "plane": _a }
